
import React from "react"
import { Autoplay } from "swiper/modules"
import { Swiper, SwiperSlide } from "swiper/react"

const sportsList = [
	{
		id: "swimming",
		name: "Swimming",
		icon: (
			<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
				<path d="M2 18c1.5 1 3.5 1 5 0s3.5-1 5 0 3.5 1 5 0 3.5-1 5 0" />
				<path d="M2 22c1.5 1 3.5 1 5 0s3.5-1 5 0 3.5 1 5 0 3.5-1 5 0" />
				<circle cx="16" cy="4" r="2" />
				<path d="m7 14 3-3 4 2 4-5" />
			</svg>
		)
	},
	{
		id: "basketball",
		name: "Basketball",
		icon: (
			<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
				<circle cx="12" cy="12" r="10" />
				<path d="M12 2a14.5 14.5 0 0 0 0 20" />
				<path d="M12 2a14.5 14.5 0 0 1 0 20" />
				<path d="M2 12h20" />
			</svg>
		)
	},
	{
		id: "table-tennis",
		name: "Table Tennis",
		icon: (
			<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
				<circle cx="10" cy="9" r="6" />
				<path d="m14.5 13.5 4 4a1.5 1.5 0 0 1-2.12 2.12l-4-4" />
				<circle cx="19" cy="5" r="2" fill="currentColor" />
			</svg>
		)
	},
	{
		id: "pickleball",
		name: "Pickleball",
		icon: (
			<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
				<rect x="5" y="3" width="11" height="13" rx="5.5" />
				<path d="M10.5 16v5" />
				<path d="M8.5 21h4" />
				<circle cx="8.5" cy="8" r="0.8" fill="currentColor" />
				<circle cx="12.5" cy="8" r="0.8" fill="currentColor" />
				<circle cx="10.5" cy="11" r="0.8" fill="currentColor" />
				<circle cx="18.5" cy="14" r="2" />
			</svg>
		)
	},
	{
		id: "zumba",
		name: "Zumba",
		icon: (
			<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
				<circle cx="12" cy="4" r="2" />
				<path d="m9 9 3 4-2 7" />
				<path d="m15 9-3 4 4 7" />
				<path d="m6 11 3-2 6-2 3 3" />
			</svg>
		)
	},
	{
		id: "badminton",
		name: "Badminton",
		icon: (
			<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
				<circle cx="15.5" cy="8.5" r="5.5" />
				<path d="m11.5 12.5-6.5 6.5" />
				<path d="M13 14 6 21" />
				<path d="M7 6 5 2l4 2 2-2 2 4" />
			</svg>
		)
	},
	{
		id: "football",
		name: "Football",
		icon: (
			<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
				<circle cx="12" cy="12" r="10" />
				<polygon points="12 7 15.5 9.5 14 13.5 10 13.5 8.5 9.5 12 7" fill="rgba(0, 212, 255, 0.25)" />
				<line x1="12" y1="2" x2="12" y2="7" />
				<line x1="15.5" y1="9.5" x2="20.5" y2="7.5" />
				<line x1="14" y1="13.5" x2="18" y2="18.5" />
				<line x1="10" y1="13.5" x2="6" y2="18.5" />
				<line x1="8.5" y1="9.5" x2="3.5" y2="7.5" />
			</svg>
		)
	},
	{
		id: "cricket",
		name: "Cricket",
		icon: (
			<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
				<path d="m4 20 11-11a2 2 0 0 1 2.8 2.8L6.8 22.8a1 1 0 0 1-1.4 0L4 21.4a1 1 0 0 1 0-1.4z" />
				<path d="m15 9 3.5-3.5a1.5 1.5 0 0 1 2.1 2.1L17 11" />
				<circle cx="19.5" cy="16.5" r="2.5" fill="rgba(0, 212, 255, 0.25)" />
			</svg>
		)
	}
]

const swiperOptions = {
	modules: [Autoplay],
	slidesPerView: 5,
	spaceBetween: 24,
	autoplay: {
		delay: 1800,
		disableOnInteraction: false,
		pauseOnMouseEnter: true,
	},
	loop: true,
	speed: 600,
	breakpoints: {
		320: {
			slidesPerView: 2,
			spaceBetween: 16,
		},
		575: {
			slidesPerView: 3,
			spaceBetween: 18,
		},
		767: {
			slidesPerView: 4,
			spaceBetween: 20,
		},
		991: {
			slidesPerView: 5,
			spaceBetween: 24,
		},
		1200: {
			slidesPerView: 6,
			spaceBetween: 24,
		},
	}
}

export default function Partner() {
	return (
		<section className="proplay-sports-ticker-section">
			<div className="themeflat-container">
				<Swiper {...swiperOptions} className="proplay-sports-swiper">
					{sportsList.map((sport) => (
						<SwiperSlide key={sport.id}>
							<div className="proplay-sport-item">
								<div className="proplay-sport-icon">
									{sport.icon}
								</div>
								<span className="proplay-sport-name">{sport.name}</span>
							</div>
						</SwiperSlide>
					))}
					{/* Duplicate slides for seamless continuous marquee loop */}
					{sportsList.map((sport) => (
						<SwiperSlide key={`${sport.id}-dup`}>
							<div className="proplay-sport-item">
								<div className="proplay-sport-icon">
									{sport.icon}
								</div>
								<span className="proplay-sport-name">{sport.name}</span>
							</div>
						</SwiperSlide>
					))}
				</Swiper>
			</div>
		</section>
	)
}

